import { Attach } from '@/components';
import { useAppClippo } from '@/core';
import { useClippoBlobs } from '@/utils';
import { Col, Divider, Row } from 'antd';
import { ExternalDocumentListPanel } from '../ExternalDocuments.List';

interface Props {
  floorplanId: string;
  className?: string;
}

export const HomeFloorplanAttachments = (props: Props) => {
  const { floorplanId, className } = props;
  const floorplanClippoProps = useAppClippo({
    noPreload: !floorplanId,
    defer: false,
    ownerId: floorplanId,
    ownerType: 'Floorplan',
  });
  const floorplanClippoBlobs = useClippoBlobs(floorplanClippoProps);

  return (
    <>
      <Row>
        <Col>
          <Attach
            className={className}
            {...floorplanClippoProps}
            showActions
            blobs={floorplanClippoBlobs.blobs}
            multiple
          />
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col>
          <ExternalDocumentListPanel referenceId={floorplanId} />
        </Col>
      </Row>
    </>
  );
};
